import React from 'react'
import HeadData from 'components/Common/HeadData'

interface Props {
  deal: App.FlightDeal
}

export function FlightDealHeadData(props: Props) {
  const { deal } = props

  return <HeadData
    imageId={deal.heroImage?.id}
    title={deal.dealName}
    description={deal.dealDescription}
  />
}
